import React from 'react';
import fr from 'facet-rest';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import { getLightBorder } from 'Components/utils';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useCommentLayoutContext } from '../../../CommentLayoutProvider';
import Container from './Container';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    minWidth: theme.dimensions.md,
    maxWidth: theme.dimensions.md,
    ...getLightBorder(theme, { left: true }),
  },
}));

const Content = () => {
  const classes = useStyles();
  const { pageContentResource } = usePageContentContext();
  const { loadThreadCollectionLink } = useCommentLayoutContext();

  useComponentDidMount(() => {
    return loadThreadCollectionLink(pageContentResource.relationship(fr.relationships.facetPlanCommentThreads.name).link('related'));
  });

  return (
    <Paper
      className={classes.root}
      elevation={0}
    >
      <Container />
    </Paper>
  );
};

export default Content;
